





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { NavLink } from '@/models/types';

@Component({
  name: 'SgsMenuListComponent'
})
export default class SgsMenuListComponent extends Vue {
  @Prop()
  public navLinks!: NavLink[];
  @Prop()
  public icons!: boolean;
  @Prop({
    type: Boolean,
    default: false
  })
  public bottom!: boolean;  

  private navigateTo(navLink: NavLink) {
    navLink.isExternal ? window.open(navLink.path, '_blank') : this.$router.push(navLink.path);
  }

  private highlightNavLink(navLink: NavLink): boolean {
    const routePath = this.$route.path.split('/');
    let bRetval = false;
    if (navLink) {
      for (const item of routePath) {
        if (navLink.path.replace('/', '').toLowerCase() === item.toLowerCase()) {
          bRetval = true;
          break;
        }
      }
    }
    return bRetval;
  }
}

Vue.component('sgs-menu-list', SgsMenuListComponent);
